import React from "react";

export default function Greminder() {
  return <div>Greminder</div>;
}
